import { IWarehouseShelf } from "../interfaces/delivery-company/warehouseshelf"

export const ShelfQRCodePrefix = "6"

export const warehouseShelfToQRcodeID = (shelf: IWarehouseShelf): string => {
    return `${ShelfQRCodePrefix}${shelf.id}`
}